import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CartProvider } from "@/context/CartContext";
import { LangProvider } from "@/context/LangContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Courses from "@/components/site/Courses";
import Webinars from "@/components/site/Webinars";
import Booking from "@/components/site/Booking";
import Store from "@/components/site/Store";
import Community from "@/components/site/Community";
import Footer from "@/components/site/Footer";
import CartSheet from "@/components/site/CartSheet";
import PranaChat from "@/components/site/PranaChat";

export default function Landing() {
  const [catalog, setCatalog] = useState(null);

  useEffect(() => {
    api.get("/catalog").then((r) => setCatalog(r.data)).catch(() => setCatalog({ courses: [], products: [], webinars: [] }));
  }, []);

  return (
    <LangProvider>
    <CartProvider>
      <div className="min-h-screen bg-parchment" data-testid="landing-page">
        <Navbar />
        <Hero />
        <Courses courses={catalog?.courses} />
        <Webinars webinars={catalog?.webinars} />
        <Booking />
        <Store products={catalog?.products} />
        <Community catalog={catalog} />
        <Footer catalog={catalog} />
        <CartSheet />
        <PranaChat />
      </div>
    </CartProvider>
    </LangProvider>
  );
}
